import React, { useState } from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import {
  Alert,
  Box,
  Button,
  FormControlLabel,
  FormGroup,
  Switch,
  TextField,
} from "@mui/material";

const EmiVerification = ({
  open,
  setOpen,
  setEmiState,
  emiState,
  handleEmiStateSubmit,
  item,
}) => {
  return (
    <GlobalDialog
      title={"Emi Verification"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      maxWidth={"xs"}
      fullWidth
      content={
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  checked={emiState.proFee || false}
                  onChange={(e) =>
                    setEmiState({ ...emiState, proFee: e.target.checked })
                  }
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label="Processing Fee"
            />
          </FormGroup>
          <Box>
            <TextField
              label="down payment (without admission fee and processing fee)"
              value={emiState.emiAmt}
              fullWidth
              onChange={(e) =>
                setEmiState({ ...emiState, emiAmt: e.target.value })
              }
            />
          </Box>
          <Box>
            {emiState.proFee && emiState.emiAmt ? (
              <Alert severity="info">
                Total paying amount is processing fee + paying amount :
                {emiState.proFee ? 530 + parseFloat(emiState.emiAmt) : ""}{" "}
              </Alert>
            ) : null}
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="outlined"
              size="small"
              sx={{ borderRadius: 4 }}
              onClick={handleEmiStateSubmit}
            >
              Add Emi Amount
            </Button>
          </Box>
        </Box>
      }
    />
  );
};

export default EmiVerification;
